import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../apps/consumer/graphql/fragments/global';

const getAccountCardConfigurationPhotosQuery = gql`
  query getAccountCardConfigurationPhotos(
    $limit: Int = 40
    $matchesOffset: Int = 0
    $favoritesOffset: Int = 0
    $identity_ids: [RecordID]
    $album_folder_id: RecordID
    $album_ids: [RecordID]
  ) {
    me {
      id
      matched_photos(
        slice: { limit: $limit, offset: $matchesOffset }
        identity_ids: $identity_ids
        album_folder_id: $album_folder_id
        album_ids: $album_ids
      ) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
          faces {
            total
          }
        }
      }
      entitled_matched_photos(
        slice: { limit: $limit, offset: $matchesOffset }
      ) {
        total
        records {
          id
          photo {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
      }
      favorited_photos(slice: { limit: $limit, offset: $favoritesOffset }) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export default getAccountCardConfigurationPhotosQuery;
